// hooks/useCacheManager.js - Gestionnaire de cache intelligent
import { useCallback, useEffect } from 'react';

const CACHE_PREFIX = 'objectifs_cache_';
const DEFAULT_CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const useCacheManager = () => {
  const getCacheKey = useCallback((endpoint, params = {}) => {
    const paramsString = Object.keys(params).length > 0 
      ? `_${JSON.stringify(params)}` 
      : '';
    return `${CACHE_PREFIX}${endpoint}${paramsString}`;
  }, []);

  const setCacheData = useCallback((key, data, customDuration = DEFAULT_CACHE_DURATION) => {
    try {
      const cacheItem = {
        data,
        timestamp: Date.now(),
        expiresAt: Date.now() + customDuration
      };
      // Utiliser les variables window au lieu du localStorage
      window.__objectivesCache = window.__objectivesCache || {};
      window.__objectivesCache[key] = cacheItem;
      console.log(`💾 Cache sauvé: ${key}`);
    } catch (error) {
      console.warn('❌ Erreur cache:', error);
    }
  }, []);

  const getCacheData = useCallback((key) => {
    try {
      const cache = window.__objectivesCache || {};
      const cached = cache[key];
      if (!cached) return null;

      if (Date.now() > cached.expiresAt) {
        delete cache[key];
        console.log(`🗑️ Cache expiré: ${key}`);
        return null;
      }

      console.log(`📦 Cache récupéré: ${key}`);
      return cached.data;
    } catch (error) {
      console.warn('❌ Erreur lecture cache:', error);
      return null;
    }
  }, []);

  const invalidateCache = useCallback((pattern = null) => {
    try {
      const cache = window.__objectivesCache || {};
      if (pattern) {
        Object.keys(cache).forEach(key => {
          if (key.includes(pattern)) {
            delete cache[key];
            console.log(`🗑️ Cache invalidé: ${key}`);
          }
        });
      } else {
        window.__objectivesCache = {};
        console.log('🗑️ Tout le cache invalidé');
      }
    } catch (error) {
      console.warn('❌ Erreur invalidation:', error);
    }
  }, []);

  const cleanExpiredCache = useCallback(() => {
    try {
      const cache = window.__objectivesCache || {};
      const now = Date.now();
      let cleaned = 0;

      Object.keys(cache).forEach(key => {
        if (cache[key] && now > cache[key].expiresAt) {
          delete cache[key];
          cleaned++;
        }
      });

      if (cleaned > 0) {
        console.log(`🧹 ${cleaned} cache(s) nettoyé(s)`);
      }
    } catch (error) {
      console.warn('❌ Erreur nettoyage:', error);
    }
  }, []);

  useEffect(() => {
    cleanExpiredCache();
  }, [cleanExpiredCache]);

  return {
    getCacheKey,
    setCacheData,
    getCacheData,
    invalidateCache,
    cleanExpiredCache
  };
};